export default {
  'screeningResolution.NO_MATCHES': 'No matches',
  'screeningResolution.FULL_MATCH': 'Full match',
  'screeningResolution.PARTIAL_MATCH': 'Partial match',
  'screeningResolution.MATCH': 'Match',
  'screeningResolution.ERROR': 'Error',
  'reviewResult.APPROVED': 'Approved',
  'reviewResult.RESUBMIT': 'Resubmit',
  'reviewResult.DECLINED': 'Declined',
  'Submit screening results': 'Submit screening results',
  'Would you like to submit screening results?': 'Would you like to submit screening results?',

  // Review Summary Page
  ' Review Summary Page': ' Review Summary Page',
  'Review Summary Page': 'Review Summary Page',

  // Screening tab labels
  'Screening Results': 'Screening Results',
  Status: 'Status',

  // Company Information step
  'Company Information': 'Company Information',
  'Company details': 'Company details',
  'Company Legal name': 'Company Legal name',
  'Company commercial name': 'Company commercial name',
  'Company Legal type': 'Company Legal type',
  'Date of establishment': 'Date of establishment',
  'Commercial registration number': 'Commercial registration number',
  'Commercial Entity number': 'Commercial Entity number',
  'Main Cr National Number': 'Main Cr National Number',
  'License issue date': 'License issue date',
  'License expiry date': 'License expiry date',
  'Parent company license number': 'Parent company license number',
  Capital: 'Capital',
  'Paid amount': 'Paid amount',
  'Announced amount': 'Announced amount',
  'Subscribed amount': 'Subscribed amount',
  'Shares count': 'Shares count',
  'Share price': 'Share price',
  'Fiscal year': 'Fiscal year',
  'Day and month': 'Day and month',
  'Calendar type': 'Calendar type',
  Activities: 'Activities',
  'Main activity': 'Main activity',
  ISIC: 'ISIC',
  'Tax registration certificate': 'Tax registration certificate',
  'Merchant have Tax registration certificate': 'Merchant have Tax registration certificate',
  'Tax registration certificate photo': 'Tax registration certificate photo',
  'Tax registration number': 'Tax registration number',
  'E-commerce merchant': 'E-commerce merchant',
  'Company period (in years)': 'Company period (in years)',
  'Date of closing': 'Date of closing',
  'Main business nature category': 'Main business nature category',
  'Main business nature': 'Main business nature',
  'Business nature category': 'Business nature category',
  'Business nature (MCC code)': 'Business nature (MCC code)',

  // Address step
  Address: 'Address',
  Country: 'Country',
  Location: 'Location',
  'Address line': 'Address line',
  'P.O. Box': 'P.O. Box',
  'Office phone number': 'Office phone number',
  'Fax number': 'Fax number',
  'Additional phone number': 'Additional phone number',
  'Additional fax number': 'Additional fax number',
  City: 'City',
  'Company email': 'Company email',
  'Merchant wants to change a business address': 'Merchant wants to change a business address',

  // Bank Account step
  'Bank account': 'Bank account',
  'Account for E-commerce': 'Account for E-commerce',
  'Please upload a scan of stamped IBAN letter.': 'Please upload a scan of stamped IBAN letter.',
  'IBAN letter': 'IBAN letter',
  'Beneficiary name': 'Beneficiary name',
  'Beneficiary name – Agent Updates': 'Beneficiary name – Agent Updates',
  'Please enter the English beneficiary name': 'Please enter the English beneficiary name',
  'Bank name (Lean verified)': 'Bank name (Lean verified)',
  'Bank name – Agent Updates': 'Bank name – Agent Updates',
  'Please enter the English bank name': 'Please enter the English bank name',
  IBAN: 'IBAN',
  'Bank name': 'Bank name',
  'Bank SWIFT code': 'Bank SWIFT code',
  'Is Verified ?': 'Is Verified ?',
  'Verification Status': 'Verification Status',
  'Derived Bank Name': 'Derived Bank Name',
  'Derived Swift Code': 'Derived Swift Code',
  'IBAN – Agent Updates': 'IBAN – Agent Updates',
  'Swift Code – Agent Updates': 'Swift Code – Agent Updates',
  'English letters and spaces only': 'English letters and spaces only',
  'Please enter the IBAN': 'Please enter the IBAN',
  'Please enter the Swift Code': 'Please enter the Swift Code',
  'Enter a valid 8 or 11 character Swift Code': 'Enter a valid 8 or 11 character Swift Code',
  'IBAN must be SA followed by 22 digits': 'IBAN must be SA followed by 22 digits',
  'IBAN invalid length': 'IBAN must be exactly 24 characters',
  'IBAN must start with SA': 'IBAN must start with "SA"',
  'IBAN check digits invalid': 'IBAN check digits (characters 3–4) must be numeric',
  'IBAN body must be alphanumeric': 'IBAN bank/account number (characters 5–24) must be alphanumeric',
  'IBAN checksum invalid': 'IBAN checksum is invalid — please verify and re-enter',

  // Risk Team Fields – Company Information Agent Updates
  'Main CR Number – Agent Updates': 'Main CR Number – Agent Updates',
  'CR Number – Agent Updates': 'CR Number – Agent Updates',
  'CR Status – Agent Updates': 'CR Status – Agent Updates',
  'Enter CR status': 'Enter CR status',
  'Confirmation Date – Agent Updates': 'Confirmation Date – Agent Updates',
  'Expiry / Suspension Date – Agent Updates': 'Expiry / Suspension Date – Agent Updates',
  'Applicant Phone Number – Agent Updates': 'Applicant Phone Number – Agent Updates',
  'Enter applicant mobile number': 'Enter applicant mobile number',
  'Fax Number – Agent Updates': 'Fax Number – Agent Updates',
  'Postal Code – Agent Updates': 'Postal Code – Agent Updates',
  'Website URL – Agent Updates': 'Website URL – Agent Updates',
  'Electronic Website – Agent Updates': 'Electronic Website – Agent Updates',
  'Enter electronic website URL': 'Enter electronic website URL',
  'City – Agent Updates': 'City – Agent Updates',
  'Capital Amount – Agent Updates': 'Capital Amount – Agent Updates',
  'Calendar Type – Agent Updates': 'Calendar Type – Agent Updates',
  'Calendar Type': 'Calendar Type',
  'Day & Month': 'Day & Month',
  'DD/MM': 'DD/MM',
  'Please enter the day & month': 'Please enter the day & month',
  'Please enter the calendar type': 'Please enter the calendar type',

  // Risk Team Fields – Address Agent Updates
  'Office phone number – Agent Updates': 'Office phone number – Agent Updates',
  'Fax number – Agent Updates': 'Fax number – Agent Updates',
  'P.O. Box – Agent Updates': 'P.O. Box – Agent Updates',
  'National Address – Agent Updates': 'National Address – Agent Updates',
  'National Address – Building Number': 'National Address – Building Number',
  'National Address – Additional Number': 'National Address – Additional Number',
  'National Address – Unit Number': 'National Address – Unit Number',
  'National Address – Street Name': 'National Address – Street Name',
  'National Address – District Name': 'National Address – District Name',
  'Regular Address – Agent Updates': 'Regular Address – Agent Updates',

  // Risk Team Fields – Managers / Shareholders Agent Updates
  'Date of birth – Agent Updates': 'Date of birth – Agent Updates',
  'ID Type': 'ID Type',
  'ID Number – Agent Updates': 'ID Number – Agent Updates',
  'Shares % – Agent Updates': 'Shares % – Agent Updates',
  'Shares count – Agent Updates': 'Shares count – Agent Updates',
  'Share Type – Agent Updates': 'Share Type – Agent Updates',
  'Entity Relationship Type – Agent Updates': 'Entity Relationship Type – Agent Updates',
  'Share Value': 'Share Value',
  'Enter share value': 'Enter share value',

  // Missing/Wrong Retrieved Data
  'Missing Value': 'Missing Value',
  'Arabic Value': 'Arabic Value',
  'Missing/Wrong Retrieved Data': 'Missing/Wrong Retrieved Data',
  'No missing or incorrect retrieved fields detected.':
    'No missing or incorrect retrieved fields detected.',
  'The following fields retrieved from Thiqah or Lean have missing or Arabic values and require agent updates:':
    'The following fields retrieved from Thiqah or Lean have missing or Arabic values and require agent updates:',

  // Company Questionnaire step
  'Company Questionnaire': 'Company Questionnaire',
  'Company website URL': 'Company website URL',
  'Number of employees': 'Number of employees',
  'The reason for applying for payment services': 'The reason for applying for payment services',
  'Do you have any established branch?': 'Do you have any established branch?',
  Yes: 'Yes',
  No: 'No',
  'Do you require tokenization?': 'Do you require tokenization?',
  'Expected turnover': 'Expected turnover',
  'Financial performance and projection': 'Financial performance and projection',
  'These are the values in SAR of expected financial performance':
    'These are the values in SAR of expected financial performance',
  'Expected average per transaction': 'Expected average per transaction',
  'Expected average per month': 'Expected average per month',
  'Expected six-month average credit balance': 'Expected six-month average credit balance',
  'Expected sales value turnover per year': 'Expected sales value turnover per year',
  'Expected number of transactions': 'Expected number of transactions',
  'These are the numbers of expected turnover': 'These are the numbers of expected turnover',
  'Expected monthly transactions': 'Expected monthly transactions',
  'Expected sales volume turnover per year': 'Expected sales volume turnover per year',
  declaration: 'declaration',
  'Do you hold any position from the below list of categories?':
    'Do you hold any position from the below list of categories?',
  'Is your company registered or incorporated in a sanctioned country?':
    'Is your company registered or incorporated in a sanctioned country?',
  'Does your company own any assets in a sanctioned country?':
    'Does your company own any assets in a sanctioned country?',
  'Additional documents': 'Additional documents',
  'Sama License Photo': 'Sama License Photo',
  'Sama License Number': 'Sama License Number',
  'AML policy and procedure document': 'AML policy and procedure document',
  'Number of AML policy and procedure document': 'Number of AML policy and procedure document',
  'Compliance Clearance Certificate photo': 'Compliance Clearance Certificate photo',
  'Compliance Clearance Certificate number': 'Compliance Clearance Certificate number',

  // Complete review step
  'Complete Application review ': 'Complete Application review ',
  Proceed: 'Proceed',
  Cancel: 'Cancel',
  Approve: 'Approve',
  Resubmit: 'Resubmit',
  Decline: 'Decline',
  'Would you like to complete application review and submit your results?':
    'Would you like to complete application review and submit your results?',
  'Complete review': 'Complete review',
  'Decision on the application': 'Decision on the application',
  'Correct review data': 'Correct review data',
  'Complete all steps to submit review': 'Complete all steps to submit review',
  Submit: 'Submit',
  'Review results': 'Review results',
  'DD.MM.YYYY HH:mm': 'DD.MM.YYYY HH:mm',
  'Decision on the application:': 'Decision on the application:',
  'Please examine the required information prior to determining whether to approve or decline the application of the client.':
    'Please examine the required information prior to determining whether to approve or decline the application of the client.',

  // Components
  'Enter your comment': 'Enter your comment',

  // Managers step
  Manager: 'Manager',
  'Personal data': 'Personal data',
  'Full name': 'Full name',
  'Date of birth': 'Date of birth',
  Nationality: 'Nationality',
  Relation: 'Relation',
  'This person is a Politically Exposed Person (PEP)':
    'This person is a Politically Exposed Person (PEP)',
  'Authorised Signatory Proof': 'Authorised Signatory Proof',
  'This person is authorised signatory': 'This person is authorised signatory',
  Email: 'Email',
  'Phone number': 'Phone number',
  'Document type': 'Document type',
  'Authorised Signatory Proof Files': 'Authorised Signatory Proof Files',
  'Authorised signatory proof type': 'Authorised signatory proof type',
  Passport: 'Passport',
  'Document number': 'Document number',
  'ID number': 'ID number',
  'Passport issue date': 'Passport issue date',
  'Passport expiry date': 'Passport expiry date',
  'Personal Document': 'Personal Document',
  'ID type': 'ID type',
  'Document Number': 'Document Number',
  'Passport Number': 'Passport Number',
  Managers: 'Managers',

  // Merchant step
  'Your application is under review': 'Your application is under review',
  'We aim to review all applications within 2 working days and we will notify you once your application has been approved.':
    'We aim to review all applications within 2 working days and we will notify you once your application has been approved.',

  // Screening
  'Trigger Automated Screening': 'Trigger Automated Screening',
  'Add manual screening': 'Add manual screening',
  'Full match': 'Full match',
  'No matches': 'No matches',
  'Partial match': 'Partial match',
  'Automated screening results': 'Automated screening results',
  'Automated screeening is in progress. Please wait.':
    'Automated screeening is in progress. Please wait.',
  'Manual verification is in progress. Please wait for the manual decision before reviewing the appplication.':
    'Manual verification is in progress. Please wait for the manual decision before reviewing the appplication.',
  'Manual screening results': 'Manual screening results',
  'Screening resolution': 'Screening resolution',
  'Screening resolution:': 'Screening resolution:',
  'Screening results': 'Screening results',
  'In case of complex ownership structure please provide comments and/or schemas that might be relevant.':
    'In case of complex ownership structure please provide comments and/or schemas that might be relevant.',
  'Is your company directly or indirectly owned/managed by a natural person residing in a sanctioned country*?':
    'Is your company directly or indirectly owned/managed by a natural person residing in a sanctioned country*?',
  'Does your company perform business / transactions on behalf of a third party?':
    'Does your company perform business / transactions on behalf of a third party?',
  'Does your company have any subsidiary, branch, office or other presence in a sanctioned country?':
    'Does your company have any subsidiary, branch, office or other presence in a sanctioned country?',
  'Does your company trade with the US or in goods that are US origin or in part contain goods of US origin?':
    'Does your company trade with the US or in goods that are US origin or in part contain goods of US origin?',
  'Does your company maintain any relationship with financial institution in a sanctioned country?':
    'Does your company maintain any relationship with financial institution in a sanctioned country?',

  // High-risk reason tags
  'Business Structure from Thiqah': 'Business Structure from Thiqah',
  'Business Activity (MCC)': 'Business Activity (MCC)',
  'Master MID Availability': 'Master MID Availability',
  'IBAN Verification Result': 'IBAN Verification Result',
  'Compliance Questions': 'Compliance Questions',
  'Screening Match': 'Screening Match',

  // Agent Activity Log
  'Activity log': 'Activity log',
  'Export all logs': 'Export all logs',
  'No changes': 'No changes',
  'An error occurred while triggering the screening. Please try again.':
    'An error occurred while triggering the screening. Please try again.',
  'Trigger Screening Failed': 'Trigger Screening Failed',
  // Shareholders step
  'Additional information': 'Additional information',
  'ADDITIONAL INFORMATION': 'ADDITIONAL INFORMATION',
  'Additional information files': 'Additional information files',
  Comment: 'Comment',
  'Edit beneficial owner': 'Edit beneficial owner',
  'First name': 'First name',
  'Last name': 'Last name',
  'Beneficial owner is a Politically Exposed Person (PEP)':
    'Beneficial owner is a Politically Exposed Person (PEP)',
  'Personal document': 'Personal document',
  'Ownership share': 'Ownership share',
  'Shares, %': 'Shares, %',
  'Beneficial owners': 'Beneficial owners',
  'Individual Shareholder': 'Individual Shareholder',
  'Legal Entity shareholder': 'Legal Entity shareholder',
  'Company license': 'Company license',
  'Company legal name': 'Company legal name',
  'Commercial Registration number': 'Commercial Registration number',
  'Entity number': 'Entity number',
  'Ownership share:': 'Ownership share:',
  'Review shareholders': 'Review shareholders',
  'Individual shareholders': 'Individual shareholders',
  'Legal entity shareholders': 'Legal entity shareholders',
  'In the meantime, you can head to our website to view more about our <1>products and services</1>.':
    'In the meantime, you can head to our website to view more about our <1>products and services</1>',
  'If you require any support whilst you wait, please <1>contact us</1>.':
    'If you require any support whilst you wait, please <1>contact us</1>.',
  'Company legal type': 'Company legal type',
  'Passport number': 'Passport number',
  by: 'by',
  'Upload a copy of the Power of Attorney showing this person as an authorised signatory':
    'Upload a copy of the Power of Attorney showing this person as an authorised signatory',
  'This person is listed on the Company License as part of the company ownership structure':
    'This person is listed on the Company License as part of the company ownership structure',
  'Country of incorporation': 'Country of incorporation',
  'Shareholder Proof Document': 'Shareholder Proof Document',
  MEMORANDUM: 'Memorandum of Association',
  ARTICLES: 'Articles of Association',
  'Minutes of board meetings': 'Minutes of board meetings',
  'Data of joint-stock companies listed in the financial market':
    'Data of joint-stock companies listed in the financial market',

  // POS UI Changes — Product Summary & Merchant Details (Part 2 & 3)
  'Product Summary': 'Product Summary',
  'E-commerce': 'E-commerce',
  'No products selected': 'No products selected',
  'Automated Screening': 'Automated Screening',
  'Merchant Details': 'Merchant Details',
  // Business Details step — commercial name changes per spec
  'Company Commercial Name [En]': 'Company Commercial Name [En]',
  'Company Commercial Name [Ar]': 'Company Commercial Name [Ar]',
  'Company Commercial Name [En] – Agent Updates': 'Company Commercial Name [En] – Agent Updates',
  'Company Commercial Name [Ar] – Agent Updates': 'Company Commercial Name [Ar] – Agent Updates',
  'Enter English commercial name': 'Enter English commercial name',
  'Enter Arabic commercial name': 'Enter Arabic commercial name',
  'Arabic letters are not allowed': 'Arabic letters are not allowed',
  'English letters are not allowed': 'English letters are not allowed',
  'City [Retrieved from Thiqah]': 'City [Retrieved from Thiqah]',
  'City [Merchant Submission]': 'City [Merchant Submission]',
  'Merchant Name (English)': 'Merchant Name (English)',
  'Merchant Name (Arabic)': 'Merchant Name (Arabic)',
  'Store Address (English)': 'Store Address (English)',
  'Store Address (Arabic)': 'Store Address (Arabic)',
  'City (Business Details)': 'City (Business Details)',
  // Product Selected panel
  'Product Selected': 'Product Selected',
  'POS Terminal': 'POS Terminal',
  'POS terminal': 'POS Terminal',

  // Risk Questionnaire review step
  'Risk Questionnaire': 'Risk Questionnaire',
  'Expected number of transactions per month': 'Expected number of transactions per month',
  'Expected monthly sales amount ({SAR})': 'Expected monthly sales amount ({SAR})',
  'Expected average transaction value ({SAR})': 'Expected average transaction value ({SAR})',
  'Expected annual revenue ({SAR})': 'Expected annual revenue ({SAR})',

  // Company Information — Company Details section
  'Company legal name – Agent Updates': 'Company legal name – Agent Updates',
  'Please enter the English company legal name': 'Please enter the English company legal name',
  'Please enter the English company commercial name': 'Please enter the English company commercial name',
  'Form Name': 'Form Name',
  'Company Characters': 'Company Characters',
  'License Issuer Name': 'License Issuer Name',
  'Partners Nationality Name': 'Partners Nationality Name',
  'Is Main': 'Is Main',
  'Parent Company License Number': 'Parent Company License Number',
  'In Liquidation Process': 'In Liquidation Process',
  'Please enter CR status': 'Please enter CR status',
  'Date of Establishment': 'Date of Establishment',
  'Company Period [In Years]': 'Company Period [In Years]',
  'Reactivation Date': 'Reactivation Date',
  'Suspension Date – Agent Updates': 'Suspension Date – Agent Updates',
  'Deletion Date': 'Deletion Date',
  'Company Phone Number': 'Company Phone Number',
  'Please enter company phone number': 'Please enter company phone number',
  'Enter company phone number': 'Enter company phone number',
  'Company Mobile Number': 'Company Mobile Number',
  'Please enter company mobile number': 'Please enter company mobile number',
  'Enter company mobile number': 'Enter company mobile number',
  'Applicant Mobile Number': 'Applicant Mobile Number',
  'Applicant mobile number': 'Applicant mobile number',
  'Website URL': 'Website URL',
  'Please enter website URL': 'Please enter website URL',
  'Enter website URL': 'Enter website URL',
  'E-commerce Merchant': 'E-commerce Merchant',
  'Select Yes or No': 'Select Yes or No',
  'Authentication Platforms': 'Authentication Platforms',
  'Store Url': 'Store URL',
  'Store Activities': 'Store Activities',

  // Company Information — National Address section
  'National Address': 'National Address',
  'National address requires agent review': 'National address requires agent review',
  'Complete mandatory national address fields before approval.':
    'Complete mandatory national address fields before approval.',
  'National Address Certificate': 'National Address Certificate',
  'National Address – Postal Code': 'National Address – Postal Code',
  'Enter postal code': 'Enter postal code',
  'Please enter postal code': 'Please enter postal code',
  'Enter building number': 'Enter building number',
  'Please enter building number': 'Please enter building number',
  'Enter additional number': 'Enter additional number',
  'Please enter additional number': 'Please enter additional number',
  'Enter unit number': 'Enter unit number',
  'Please enter unit number': 'Please enter unit number',
  'Enter street name': 'Enter street name',
  'Please enter street name': 'Please enter street name',
  'Enter district name': 'Enter district name',
  'Please enter district name': 'Please enter district name',
  'Regular Address (Full Address)': 'Regular Address (Full Address)',
  'Enter full address': 'Enter full address',
  'Please enter full address': 'Please enter full address',
  'National Address – Merchant Name': 'National Address – Merchant Name',
  'Enter merchant name': 'Enter merchant name',
  'National Address – City': 'National Address – City',
  'Enter city': 'Enter city',
  'National Address – Region Name': 'National Address – Region Name',
  'Enter region name': 'Enter region name',
  'National Address – Address ID': 'National Address – Address ID',
  'Enter address ID': 'Enter address ID',
  'National Address – Status': 'National Address – Status',
  'Enter status': 'Enter status',

  // Company Information — Capital section
  'CR capital': 'CR Capital',
  'Please enter capital amount': 'Please enter capital amount',
  'Enter capital amount': 'Enter capital amount',
  'Contribution Capital Type': 'Contribution Capital Type',
  'Contribution Capital Cash': 'Contribution Capital Cash',
  'Contribution Capital inKind': 'Contribution Capital In-Kind',
  'Contribution Value': 'Contribution Value',
  'Contribution Capital Total Cash': 'Contribution Capital Total Cash',
  'Contribution Capital Total inKind': 'Contribution Capital Total In-Kind',
  'Stock Capital Type': 'Stock Capital Type',
  'Stock Capital Value': 'Stock Capital Value',
  'Stock Capital Cash': 'Stock Capital Cash',
  'Stock Capital InKind': 'Stock Capital In-Kind',
  'Announced Stock Capital': 'Announced Stock Capital',
  'Paid Stock Capital': 'Paid Stock Capital',
  'Shares Price': 'Shares Price',

  // Company Information — Fiscal Year section
  'Enter calendar type': 'Enter calendar type',

  // Company Information — Main Business Nature section
  'Main Business Activity': 'Main Business Activity',
  'Search activities...': 'Search activities...',
  'No results found': 'No results found',
  Previous: 'Previous',
  of: 'of',
  Next: 'Next',
  'Master MID': 'Master MID',
  'Master TID': 'Master TID',

  // Company Information — Tax section
  'Tax Registration Number': 'Tax Registration Number',

  // Company Questionnaire review page
  'Are you, or a direct family member, or any individual associated with your business, a Politically Exposed Person (PEP)?':
    'Are you, or a direct family member, or any individual associated with your business, a Politically Exposed Person (PEP)?',
  'Name of Politically Exposed Person': 'Name of Politically Exposed Person',
  'Do your business activities, owners, or officials have any direct or indirect involvement with, or interests in, any sanctioned countries, territories, or individuals/entities listed on sanctions lists? \nThis includes any current operations, offices, financial relationships, or planned engagements that may contravene applicable sanctions regulations.':
    'Do your business activities, owners, or officials have any direct or indirect involvement with, or interests in, any sanctioned countries, territories, or individuals/entities listed on sanctions lists? \nThis includes any current operations, offices, financial relationships, or planned engagements that may contravene applicable sanctions regulations.',
  'the countries, individuals, business activities, goods/services involved (including their use, origin, and destination)':
    'the countries, individuals, business activities, goods/services involved (including their use, origin, and destination)',

  // Manager & Shareholder review — PersonReviewFormItems
  'Full name – Agent Updates': 'Full name – Agent Updates',
  'Nationality – Agent Updates': 'Nationality – Agent Updates',
  'Please enter the English full name': 'Please enter the English full name',
  'Please select the nationality': 'Please select the nationality',
  'Manager Relationship Type': 'Manager Relationship Type',
  'Please enter the relationship type': 'Please enter the relationship type',
  'Enter relationship type': 'Enter relationship type',
  'ID Number – Agent Update': 'ID Number – Agent Update',
  'Please enter the ID type': 'Please enter the ID type',
  'Enter ID type': 'Enter ID type',
  'Please enter the ID number': 'Please enter the ID number',
  'Enter ID number': 'Enter ID number',

  // Individual Shareholder review — ownership share section
  'Shares %': 'Shares %',
  'Enter shares %': 'Enter shares %',
  'Enter shares count': 'Enter shares count',
  'Share Type': 'Share Type',
  'Enter share type': 'Enter share type',
  'Entity Relationship Type': 'Entity Relationship Type',
  'Enter entity relationship type': 'Enter entity relationship type',
  'Download File': 'Download File',
  'review.contractReview': 'Agreement',
  contractReview: 'Agreement',
  Agreement: 'Agreement',
  'National Address Missing': 'National Address Missing',
};
